export const isNumberOrCurrency = value => {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'number') {
    return true;
  }
  const regExp = RegExp(/^[\d,.$]+$/);
  return regExp.test(value);
};